














































import { Component, Vue } from 'vue-property-decorator';
import { settlementUnitManage } from './settlementUnit';
import { timeFormat } from '@/utils/other';

type ISettlementUnitInfo = ISettlementUnit.IResponse.ISettlementUnitInfo;

interface ISettlementUnitRowInfo extends ISettlementUnitInfo {
  editable: boolean;
  isCreate?: boolean;
  [key: string]: any;
}

const columns = [
  {
    slots: { title: 'nameTitle' },
    dataIndex: 'name',
    scopedSlots: { customRender: 'name'},
  },
  {
    slots: { title: 'createrTitle' },
    dataIndex: 'createdName',
    scopedSlots: { customRender: 'createdName'},
    width: '15%',
    align: 'center',
  },
  {
    slots: { title: 'activeTitle' },
    dataIndex: 'active',
    scopedSlots: { customRender: 'active'},
    width: '10%',
    align: 'center',
  },
  {
    slots: { title: 'actionTitle' },
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width: '10%',
    align: 'center',
  },
];
let cacheSettlementUnit: ISettlementUnitRowInfo | null = null;

@Component({
  name: 'SettlementUnit',
  filters: {
    timeFormat,
  },
})
export default class SettlementUnit extends Vue {
  private settlementUnitList: ISettlementUnitRowInfo[] = [];
  private loading = false;
  private columns = columns;
  private editingKey = '';
  private pagination = {
    hideOnSinglePage: true,
  };
  private spinning = false;
  get isEditing() {
    return this.editingKey !== '';
  }
  private created() {
    this.refreshSettlementUnits();
  }
  private refreshSettlementUnits() {
    this.resetStatus();
    this.spinning = true;
    settlementUnitManage.requestGetSettlementUnits().then((res) => {
      this.updateSettlementUnitList();
      this.spinning = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.spinning = false;
    });
  }
  private resetStatus() {
    this.editingKey = '';
  }
  private updateSettlementUnitList() {
    this.settlementUnitList = settlementUnitManage.data.map((settlementUnit) => {
      return {
        ...settlementUnit,
        editable: false,
      };
    });
  }
  private createSettlementUnit() {
    const todoTopy = settlementUnitManage.createSettlementUnit();
    this.settlementUnitList.unshift({
      ...todoTopy,
      editable: true,
      isCreate: true,
    });
    this.editingKey = todoTopy.id;
  }
  private editSettlementUnit(settlementUnitRow: ISettlementUnitRowInfo, index: number) {
    cacheSettlementUnit = {...this.settlementUnitList[index]};
    settlementUnitRow.editable = true;
    this.editingKey = settlementUnitRow.id;
  }
  private cancelEdit(settlementUnitRow: ISettlementUnitRowInfo, index: number) {
    this.editingKey = '';
    if (settlementUnitRow.isCreate) {
      this.settlementUnitList.shift();
      return;
    }
    this.settlementUnitList[index] = {...cacheSettlementUnit!};
  }
  private saveSettlementUnit(settlementUnitRow: ISettlementUnitRowInfo) {
    const {id, name, active} = settlementUnitRow;
    const newSettlementUnit = {
      id,
      data: {
        name,
        active,
      },
    };
    this.loading = true;
    settlementUnitManage.requestUpdateSettlementUnit(newSettlementUnit).then((res) => {
      if (settlementUnitRow.isCreate) {
        settlementUnitManage.addSettlementUnit(settlementUnitRow);
        settlementUnitRow.isCreate = false;
      } else {
        settlementUnitManage.changeSettlementUnit(settlementUnitRow);
      }
      settlementUnitRow.editable = false;
      this.editingKey = '';
      this.$message.success(res);
      this.loading = false;
    }).catch((err) => {
      this.$message.warning(err);
      this.loading = false;
    });
  }
  private submitDelete(settlementUnitId: string) {
    settlementUnitManage.requestDeleteSettlementUnit(settlementUnitId).then((res) => {
      this.updateSettlementUnitList();
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleDelSettlementUnit(settlementUnit: ISettlementUnitRowInfo) {
    this.$confirm({
      title: this.$t('operation.confirmMsg', {operation: this.$t('form.delete')}).toString(),
      onOk: () => {
        this.submitDelete(settlementUnit.id);
      },
    });
  }
  private handleChange(value: string, rowId: string, column: string) {
    const newSettlementUnits = [...this.settlementUnitList];
    const target = newSettlementUnits.filter((settlementUnitRow) => rowId === settlementUnitRow.id)[0];
    if (target) {
      const index = this.settlementUnitList.findIndex((settlementUnit) => target.id === settlementUnit.id);
      if (['active'].includes(column)) {
        target[column] = value ? true : false;
      } else {
        target[column] = value;
      }
      this.settlementUnitList[index] = target;
    }
  }
}
